export interface Tomo {
  n: string
  cover: string
  title: string
  subtitle: string
  features: string[]
}

export interface Bonus {
  n: string
  cover: string
  title: string
  price: string
}

export const tomos: Tomo[] = [
  {
    n: 'I',
    cover:
      'https://cdn.magicpatterns.com/uploads/jynD7f8T5XDD9UyyetqbjW/Captura_de_pantalla_2026-07-09_005238.png',
    title: 'Fundamentos operativos y protección del terapeuta',
    subtitle: 'El sistema operativo completo del terapeuta profesional.',
    features: [
      'Psicología del orden clínico',
      'Protocolo de sellado áurico profesional',
      'Estructura de la sesión: KAI / YONG / HE',
      'Higiene energética del espacio entre pacientes',
      'Ergonomía energética del terapeuta',
      'Diagnóstico visual rápido del estado del paciente',
      'El terapeuta como ser completo',
      'Mapa del año terapéutico',
    ],
  },
  {
    n: 'II',
    cover:
      'https://cdn.magicpatterns.com/uploads/p8fdYg1hTd5WZcY6GboRPG/Captura_de_pantalla_2026-07-09_005317.png',
    title: 'Vademécum de sesiones y tratamientos',
    subtitle: 'La biblioteca clínica de Chi Kung más completa en español.',
    features: [
      'Biblioteca completa de series terapéuticas',
      'Chi Kung clasificado por sistemas orgánicos',
      'Protocolos por patología específica',
      'Manejo de crisis energéticas durante la sesión',
      'Tareas de práctica para el paciente en casa',
      'Series adaptadas por nivel del paciente',
    ],
  },
  {
    n: 'III',
    cover:
      'https://cdn.magicpatterns.com/uploads/qA8w8WpWd7T6Q58rhShCHT/Captura_de_pantalla_2026-07-09_005335.png',
    title: 'Planificador anual 365',
    subtitle: 'Planificación estratégica de 52 semanas por estaciones.',
    features: [
      'Planificación por estaciones energéticas',
      'Agenda completa de 52 semanas',
      'Plantillas de seguimiento clínico del paciente',
      'Organización profesional del consultorio',
      'Metas terapéuticas por trimestre',
      'Registro de evolución por paciente',
    ],
  },
]

export const bonuses: Bonus[] = [
  {
    n: '01',
    cover:
      'https://cdn.magicpatterns.com/uploads/izXiz8qHHHmhcF7NzwFYpE/Portada_bono_1.png',
    title: 'Cuaderno de planificación imprimible',
    price: 'USD 9',
  },
  {
    n: '02',
    cover:
      'https://cdn.magicpatterns.com/uploads/soQDKuVirwVNDfDTRKho9o/Portada_bono_2.png',
    title: '52 guiones de visualización',
    price: 'USD 12',
  },
  {
    n: '03',
    cover:
      'https://cdn.magicpatterns.com/uploads/mj6k5ncoTuy7xdPtbBKVa3/Portada_bono_3.png',
    title: 'Kit de gráficos para el consultorio',
    price: 'USD 8',
  },
  {
    n: '04',
    cover:
      'https://cdn.magicpatterns.com/uploads/fdQnLkSDXyfusoJCeSWn4K/Portada_bono_4.png',
    title: 'Protocolo de Chi Kung adaptado',
    price: 'USD 9',
  },
  {
    n: '05',
    cover:
      'https://cdn.magicpatterns.com/uploads/eM4GmmLyaHVhBFXDtCHhqf/Portada_bono_5.png',
    title: 'Audioentrenamiento «Limpieza rápida»',
    price: 'USD 8',
  },
  {
    n: '06',
    cover:
      'https://cdn.magicpatterns.com/uploads/igdVVLtCTu8WRsKKBwXCjE/Portada_bono_6.png',
    title: 'Curaduría de sonidos sanadores',
    price: 'USD 8',
  },
]
